<script setup lang="ts">
import { computed } from "vue";
import { t } from "@/plugins/i18n";

const included = defineModel<boolean>({ required: true });

const hint = computed(() =>
	included.value
		? t("filterDialog.values.headerIncluded")
		: t("filterDialog.values.headerExcluded")
);
</script>
<template>
	<div class="polarity" v-tooltip="hint">
		<span class="text-caption text-medium-emphasis">
			{{ t("filterDialog.values.polarity") }}
		</span>
		<!-- `mandatory` keeps one side chosen at all times: without it, clicking the
		active button deselects it and the model goes undefined instead of flipping. -->
		<v-btn-toggle
			v-model="included"
			mandatory
			density="compact"
			variant="outlined"
			color="primary"
		>
			<v-btn :value="true" size="small">
				{{ t("filterDialog.values.polarityInclude") }}
			</v-btn>
			<v-btn :value="false" size="small" color="error">
				{{ t("filterDialog.values.polarityExclude") }}
			</v-btn>
		</v-btn-toggle>
	</div>
</template>
<style scoped lang="scss">
.polarity {
	display: flex;
	align-items: center;
	gap: 0.5rem;

	// The rest of the dialog is sentence case; Vuetify uppercases buttons.
	:deep(.v-btn) {
		text-transform: none;
	}
}
</style>
